import { createEntityAdapter, EntityAdapter, EntityState } from '@ngrx/entity';
import { createReducer, on } from '@ngrx/store';
import { TocTypeActions } from '.';
import { TocTypeInterface } from '../../+models';

export const NAME = 'tocTypes';

export interface State extends EntityState<TocTypeInterface> {
  loaded: boolean;
  error?: any;
}

export const adapter: EntityAdapter<TocTypeInterface> = createEntityAdapter<TocTypeInterface>();

export const initialState: State = adapter.getInitialState({
  loaded: false,
});

export const reducer = createReducer(
  initialState,
  on(TocTypeActions.tocTypesLoaded, (state, { tocTypes }) =>
    adapter.setAll(tocTypes, {
      ...state,
      loaded: true,
    })
  ),

  on(TocTypeActions.clearTocTypes, (state) =>
    adapter.removeAll({
      ...state,
      loaded: false,
    })
  ),

  on(TocTypeActions.tocTypesLoadError, (state, { error }) => ({
    ...state,
    error,
    loaded: false,
  }))
);

export const { selectIds, selectEntities, selectAll } = adapter.getSelectors();
